"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationSend = exports.notificationPermissionGranted = exports.notificationPermissionDenied = exports.audioPlay = exports.debounce = void 0;

var _godaddy = _interopRequireDefault(require("./images/godaddy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DENIED = 'denied';
var GRANTED = 'granted';

var debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var interval = arguments.length > 2 ? arguments[2] : undefined;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    interval = setTimeout(function () {
      interval = null;
      callback.apply(void 0, args);
    }, time);
  };
};

exports.debounce = debounce;

var audioPlay = function audioPlay(soundURI) {
  if (window.Audio) {
    new window.Audio(soundURI).play();
    return true;
  }

  return false;
};

exports.audioPlay = audioPlay;

var notificationPermissionDenied = function notificationPermissionDenied() {
  return window.Notification && window.Notification.permission === DENIED;
};

exports.notificationPermissionDenied = notificationPermissionDenied;

var notificationPermissionGranted = function notificationPermissionGranted() {
  return window.Notification && window.Notification.permission === GRANTED;
};

exports.notificationPermissionGranted = notificationPermissionGranted;

var notificationSend = function notificationSend(_ref) {
  var body = _ref.body,
      permissionGranted = _ref.permissionGranted,
      title = _ref.title;
  return new Promise(function (resolve) {
    if (!window.Notification) {
      // browser does not support notifications
      resolve(false);
    } else if (notificationPermissionDenied()) {
      // permission is denied, quit
      resolve(false);
    } else if (notificationPermissionGranted()) {
      // permission is already granted, create a notification
      new window.Notification(title, {
        body: body,
        icon: _godaddy.default
      }); // eslint-disable-line no-new

      resolve(true);
    }

    window.Notification.requestPermission(permissionGranted).then(function (permission) {
      if (permission === GRANTED) {
        // permission granted, create a notification
        new window.Notification(title, {
          body: body,
          icon: _godaddy.default
        }); // eslint-disable-line no-new

        resolve(true);
      }

      resolve(false);
    });
  });
};

exports.notificationSend = notificationSend;